"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TheBlockadeAbilityHandler = exports.TheBlockadeActorAbilityFactory = exports.TheBlockadeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class TheBlockadeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TheBlockade;
        this.__typeName = "TheBlockade";
    }
}
exports.TheBlockadeAbilityArgs = TheBlockadeAbilityArgs;
let TheBlockadeActorAbilityFactory = class TheBlockadeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TheBlockade", "AllAllies", 4);
    }
};
TheBlockadeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TheBlockade")
], TheBlockadeActorAbilityFactory);
exports.TheBlockadeActorAbilityFactory = TheBlockadeActorAbilityFactory;
let TheBlockadeAbilityHandler = class TheBlockadeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
                const buffSequence = sequence.pushSequence("parallel");
                for (const ally of allies) {
                    container.applyBuff({
                        creatorId: ability.invokerId,
                        targetId: ally,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_1.LinkedEffectsEffectArgs([
                            new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.AllDamageResistance, container.getLevel(ability.invokerId)),
                            new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Will, container.getPercentOfBaseAttributeScore(ally, 4, "Will"))
                        ], false),
                        sequence: buffSequence.pushSequence("sequential"),
                    });
                }
            }
        });
    }
};
TheBlockadeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TheBlockade)
], TheBlockadeAbilityHandler);
exports.TheBlockadeAbilityHandler = TheBlockadeAbilityHandler;
